import styled from 'styled-components';

type DrawerWrapperProps = {
  $backdropOpacity?: number;
};

export const DrawerWrapper = styled.div<DrawerWrapperProps>`
  /* This will only work if the drawer's portal prop is false */
  [data-anvil-component='Backdrop'] {
    opacity: ${({ $backdropOpacity }) =>
      $backdropOpacity !== undefined
        ? `${$backdropOpacity}% !important`
        : 'unset'};
  }
`;
